import React from "react"
import { useSelector } from "react-redux"

import { MtDriveVersion } from "server/models"
import {
    StoreType,
    VersionList,

    LoadDriveVersionsByIds,
    createFileName,
} from "client/store"
import {
    SelectDropdownItem,
    Empty,
} from "client/components"
import { SelectDropdownStyled } from "./styled"

const RECENT_PROJECT_VERSIONS = "RECENT_PROJECT_VERSIONS"

type RecentVersionsByProject = { [projectId: number]: MtDriveVersion[] }

interface RecentVersionsProps {
    onSelect: (version: MtDriveVersion) => void
}

export const RecentVersions = ({
    onSelect,
}: RecentVersionsProps) => {
    const project = useSelector((state: StoreType) => state.project.projectView)
    const lang = useSelector((state: StoreType) => state.system.lang)

    const versionsByProject = GetRecentVersions()
    const versions = versionsByProject[project.id] || []

    return (
        <SelectDropdownStyled
            title={`+ ${lang.recentFiles}`}
            row="true"
        >
            {
                versions.map((version) => (
                    <SelectDropdownItem
                        key={version.id}
                        onClick={() => onSelect(version)}
                    >
                        {`${createFileName(version.file)} - ${lang.revision} ${version.revision}`}
                    </SelectDropdownItem>
                ))
            }
            {
                versions.length === 0
                && <SelectDropdownItem><Empty /></SelectDropdownItem>
            }
        </SelectDropdownStyled>
    )
}

export const GetRecentVersions = () => {
    const recentVersions = window.localStorage.getItem(RECENT_PROJECT_VERSIONS)
    const recentVersionsByProject: RecentVersionsByProject = recentVersions ? JSON.parse(recentVersions) : {}
    return recentVersionsByProject
}

export const SetRecentVersions = (projectId: number, versions: MtDriveVersion[]) => {
    const newVersions: MtDriveVersion[] = versions.slice()
    const versionIds: number[] = []
    versions.forEach((version) => {
        versionIds.push(version.id)
    })

    const versionsByProject = GetRecentVersions()
    if (versionsByProject[projectId]) {
        versionsByProject[projectId].forEach((version) => {
            if (!versionIds.includes(version.id)) {
                newVersions.push(version)
            }
        })
    }

    versionsByProject[projectId] = newVersions.slice(0, 10)

    window.localStorage.setItem(
        RECENT_PROJECT_VERSIONS,
        JSON.stringify(versionsByProject),
    )
}

export const CheckRecentVersions = (projectId: number) => {
    const versionsByProject = GetRecentVersions()
    const versions = versionsByProject[projectId] || []

    const versionIds: number[] = []
    versions.forEach((version) => {
        versionIds.push(version.id)
    })

    return LoadDriveVersionsByIds(versionIds).then((versionsLoaded) => {
        const versionsLoadedList: VersionList = {}
        versionsLoaded.forEach((version) => {
            versionsLoadedList[version.id] = version
        })

        const versionsChecked: MtDriveVersion[] = []
        versions.forEach((version) => {
            // push loaded version to the list to update file name
            if (versionsLoadedList[version.id]) versionsChecked.push(versionsLoadedList[version.id])
        })

        versionsByProject[projectId] = versionsChecked

        window.localStorage.setItem(
            RECENT_PROJECT_VERSIONS,
            JSON.stringify(versionsByProject),
        )
    })
}
